import computeClassName from '../../../../../utils/computeClassName';
import computeTagName from '../../../../../utils/computeTagName';

const constants = Object.freeze({
  TAG_DEFAULT: 'span',
  CLASSNAME_BASE: 'flex-row text-cc-body-small xs:text-cc-body-medium text-cc-gray-80',
  CLASSNAME_IS_INLINE: {
    true: 'inline-flex',
    false: 'flex'
  }
});

const propsDefaults = Object.freeze({
  partnerRole: '',
  partnerLevel: '',
  isInline: true,
  tag: constants.TAG_DEFAULT
});

function getComputedClassName(propsClassName, isInline) {
  return computeClassName(propsClassName, `${constants.CLASSNAME_BASE} ${constants.CLASSNAME_IS_INLINE[isInline]}`);
}

export default function PartnerRolesAndLevelsEmpty({
  isInline = propsDefaults.isInline,
  tag =  propsDefaults.tag,
  className
}) {
  const ComputedTagName = computeTagName(tag, constants.TAG_DEFAULT);
  const computedClassName = getComputedClassName(className, isInline);

  return (
    <ComputedTagName className={computedClassName}>
      <span>&nbsp;</span>
    </ComputedTagName>
  );

}
